import { resolveUrl } from '@portals/geo-utils';

import { setHeaders } from '#adapter/headers';

export const quizFetch = (url: string | URL | Request, init?: RequestInit | undefined): Promise<Response> => {
    return fetch(resolveUrl(window.ENDPOINT_QUIZ + (url as string)), {
        ...init,
        credentials: 'include',
        headers    : setHeaders(init?.headers)
    });
};
